/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialTagResponse } from '../../models/editorial-tag-response';

export interface GetEditorialTag$Params {
  id: number;
}

export function getEditorialTag(http: HttpClient, rootUrl: string, params: GetEditorialTag$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialTagResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialTag.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialTagResponse>;
    })
  );
}

getEditorialTag.PATH = '/api/editorial/tags/{id}';
